import { Directive, Input } from '@angular/core';

/**
 * Directive that marks the dialog action footer.
 * Supports `align` input for positioning buttons.
 *
 * Usage: `<div appDialogActions align="end">...</div>`
 */
@Directive({
  selector: '[appDialogActions], [app-dialog-actions], app-dialog-actions',
  host: {
    class: 'dialog__actions',
    '[class.dialog__actions--end]': 'align === "end"',
    '[class.dialog__actions--center]': 'align === "center"',
  },
})
export class DialogActionsDirective {
  @Input() align: 'start' | 'center' | 'end' = 'start';
}
